import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { Icon } from '@powdr/components/icon';
import { Link } from '@powdr/components/link';
import {
  AlternatingBlockLayoutOptions, BlockTypes, Breakpoints, ThemeProps as Prop,
} from '@powdr/constants';
import { useWindowResize } from '@powdr/hooks';
import { ContentBlockType } from '@powdr/model';
import { themeUtil, getBackgroundImageSrc, clamp } from '@powdr/utils';
import theme from '@powdr/woodwardpa/theme/theme';

const CPNT = BlockTypes.SPLIT_ALT;

// styled components
const ContentBlockFloat2 = styled.div`
  background-image: ${({ image }) => `url('${image}')`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 600px;

  ${Breakpoints.mobile(css`
    height: 400px;
  `)}
`;

const ContentWrapper = styled.div`
  display: flex;
  padding: 25px;
  gap: 15px;
  flex-direction: column;
`;

const ContentSection = styled.div`
  padding: 15px;
  background-color: ${({ colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, colorProfile)};
  overflow-x: hidden;

  h3 {
    color: ${({ colorProfile }) => themeUtil(Prop.HEADER, CPNT, colorProfile)};
  }

  p {
    color: ${({ colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, colorProfile)};
  }
`;

const StyledLink = styled(Link)`
  width: fit-content;
`;

// TODO: bg image utility for the BGImage once built
export const Float2 = ({
  title, copy, blockType, ariaLabel,
  buttonEnabled, buttonLink, buttonText, buttonTarget, buttonClick,
  colorProfile, image, columnOption, isStaticImageLink,
}) => {
  const [bgImage, setBgImage] = useState('');
  const resize = useWindowResize();

  useEffect(() => {
    if (resize.windowWidth) {
      setBgImage(
        (!isStaticImageLink)
          ? getBackgroundImageSrc(image?.src, resize.windowWidth, columnOption)
          : image.src,
      );
    }
  }, [resize.windowWidth]);

  return (
    <ContentBlockFloat2
      colorProfile={colorProfile}
      className={`content-block-${blockType} `}
      image={bgImage}
    >
      <ContentWrapper>
        <ContentSection colorProfile={colorProfile}>
          <p className="cb-copy">{copy}</p>
          <h3 className="cb-title">{title}</h3>
        </ContentSection>
        {(buttonEnabled && buttonText) && (
        <StyledLink
          type="button"
          className="button with-background"
          href={buttonLink}
          target={buttonTarget}
          onClick={() => buttonClick()}
          aria-label={ariaLabel}
        >
          {buttonText}
        </StyledLink>
        )}
      </ContentWrapper>
    </ContentBlockFloat2>
  );
};

Float2.propTypes = PropTypes.objectOf(ContentBlockType).isRequired;
